<table #table class="table" cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="onColumnDrop($event)">
  @if( $isCaptionExists() ){
  <ng-content select="caption">
    <caption>
      <div class="caption__body">
        <h3 class="caption__title">{{ $caption() ?? 'Table' }}</h3>
      </div>
    </caption>
  </ng-content>
  } @if( !$state().isCollapsed ){ @let numBodyRows = $processedData().length;
  <thead>
    <tr class="table__tr">
      <th class="table__th is-toggle-col"></th>
      @for( col of $visibleColumns(); track col.key; let isFirstCol = $first; let numCols = $count ){
      <th
        class="table__th"
        cdkDrag
        [cdkDragDisabled]="col.reorderable === false || isFirstCol || numCols < 3"
        [class.is-numerical]="col.isNumerical"
        [class.is-sortable]="col.sortable !== false && numBodyRows > 2"
        (click)="toggleSort(col)"
      >
        <div class="table__th__content">
          @if( isLabelComplex(col.label) ){
          <p
            class="table__th__label"
            [attr.data-tooltip]="$browserHasPointer() ? col.label.secondary : null"
            [innerHTML]="col.label.primary"
          >
            @if( !$browserHasPointer() ){
            <br /><small [innerHTML]="col.label.secondary"></small>
            }
          </p>
          } @else {
          <span class="table__th__label" [innerHTML]="col.label"></span>
          } @if( $sortColumn() === col.key ){
          <span class="is-sort-indicator">{{ $sortDirection() === 'asc' ? '↑' : '↓' }}</span>
          }
        </div>
        <div
          *cdkDragPreview
          class="is-drag-preview"
          [innerHTML]="isLabelComplex(col.label) ? col.label.primary : col.label"
        ></div>
      </th>
      }
    </tr>
  </thead>
  <tbody>
    @for( row of $processedData(); track $index; let idx = $index ){
    <tr class="table__tr">
      <td class="table__td is-toggle-col">
        @if( $hiddenColumns().length > 0 ){
        <button type="button" class="table__expand-btn" (click)="toggleRow(idx)">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor">
            @if( $expandedRows().has(idx) ){
            <path
              d="M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z"
            />
            } @else {
            <path
              d="M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
            />
            }
          </svg>
        </button>
        }
      </td>
      @for (col of $visibleColumns(); track col.key) {
      <td class="table__td" [class.is-numerical]='(row[col.key] | numberOrString) === "number"'>{{ row[col.key] }}</td>
      }
    </tr>
    @if( $expandedRows().has(idx) && $hiddenColumns().length > 0 ){
    <tr class="table__tr is-expansion-row">
      <td class="table__td" [attr.colspan]="$visibleColumns().length + 1">
        <dl class="table__expansion-content">
          @for (col of $hiddenColumns(); track col.key) {
          <div class="table__hidden-item">
            @if( isLabelComplex(col.label) ){
            <dt class="table__hidden-label" [innerHTML]='col.label.primary +" "+ col.label.secondary'></dt>
            } @else {
            <dt class="table__hidden-label" [innerHTML]="col.label"></dt>
            }
            <dd class="table__hidden-value" [innerHTML]='row[col.key] || "n/a"'></dd>
          </div>
          }
        </dl>
      </td>
    </tr>
    } } @empty {
    <tr class="table__tr">
      <td class="table__td empty-state" [attr.colspan]="$columns().length + 1">No data available.</td>
    </tr>
    }
  </tbody>
  @if( $footer(); as footer ){
  <tfoot>
    <tr class="table__tr">
      <td class="table__td is-toggle-col"></td>
      @for( col of $visibleColumns(); track col.key ){
      <td class="table__td" [class.is-numerical]='(footer[col.key] | numberOrString) === "number"'>
        {{ footer[col.key] ?? '' }}
      </td>
      }
    </tr>
  </tfoot>
  } }
</table>
